import type { ProductsCompany } from "~/types/common"

const gsProducts = [
  { pCode: 'P101Q9LT', csCode: 'CS01724802', name: 'Goal Zero Yeti 200x 178вт*год' },
  { pCode: 'P101Q86M', csCode: 'CS01724771', name: 'Goal Zero Yeti 500x 505вт*год' },
  { pCode: 'P101Q86I', csCode: 'CS01724770', name: 'Goal Zero Yeti 1000x 1030вт*год' },
  { pCode: 'P101Q86G', csCode: 'CS01724753', name: 'Goal Zero Yeti 1500x 1516вт*год' },
  { pCode: 'P101Q857', csCode: 'CS01844740', name: 'Goal Zero Yeti 6000x 6100вт*год' },

  { pCode: 'P101S187', csCode: 'CS01819589', name: 'Champion 2.0 кВт газ/бензин інверторний' },
  { pCode: 'P101RCQM', csCode: 'CS01734497', name: 'Champion 2.2 кВт газ/бензин інверторний' },
  { pCode: 'P101TGPK', csCode: 'CS01846954', name: 'Champion 3.5 кВт газ/бензин інверторний' },
  { pCode: 'P101RCLZ', csCode: 'CS01734104', name: 'Champion 3.6 кВт газ/бензин інверторний' },
  { pCode: 'P101TGPN', csCode: 'CS01846956', name: 'Champion 2.8 кВт газ/бензин' },
  { pCode: 'P101RB6O', csCode: 'CS01733945', name: 'Champion 7.0 кВт газ/бензин' },
  { pCode: 'P101TGPW', csCode: 'CS01846958', name: 'Champion 3.5 кВт бензин' },
  { pCode: 'P101TGPQ', csCode: 'CS01846957', name: 'Champion 9.0 кВт бензин' }
]

const sbProducts = [
  { pCode: 'P101TDVJ', csCode: 'CS01832696', name: 'Саундбар Magnat SBW 280 260Вт' },
  { pCode: 'P101TDVK', csCode: 'CS01832697', name: 'Саундбар Magnat SBW 300 420Вт' },
  { pCode: 'P02113FY', csCode: 'CS01732686', name: 'Проектор Jimveo C11 1080p 8500 Лм Wi-Fi' },
  { pCode: 'P08273VK', csCode: 'CS01735214', name: 'Навушники Nothing Ear 1' },
  { pCode: 'P101Q86I', csCode: 'CS01724770', name: 'Goal Zero Yeti 1000x 1030вт*год' },
  { pCode: 'P101RCQM', csCode: 'CS01734497', name: 'Champion 2.2 кВт газ/бензин інверторний' },
  { pCode: 'P101PP9A', csCode: 'CS01780825', name: 'Мотокоса McCulloch бензин, 600 Вт' },
  { pCode: 'P101NSFW', csCode: 'CS01500445', name: 'Перфоратор Hikoki SDS+ кейс (2 акб + ЗП)' }
]

export const PROMOCODE_COMPANIES: { [key: string]: ProductsCompany } = {
  stage: {
    categories: [],
    products: [
      { pCode: 'P00804OG', csCode: 'CSA93OA6H', name: 'Test product 1' },
      { pCode: 'P00461QC', csCode: 'CS00000929', name: 'Test product 2' },
      { pCode: 'P00990BZ', csCode: 'CSW3EMRUZ', name: 'Test product 3' },
      { pCode: 'P00804OG', csCode: 'CSA93OA6H', name: 'Test product 4' }
    ],
    salePercent: 5
    // promocodes: ['TST10']
  },
  zsu: {
    categories: [],
    products: [],
    salePercent: 15
  },
  bf: {
    categories: [
      {
        link: '/seller/synthetic?category=C136911&ordering=rating&fp00004=0ecebe7155994928a796c30a45778a42&fo00007=true&utm_source=black&utm_medium=goal',
        name: 'ЗАРЯДНІ СТАНЦІЇ',
        img: '9e5124f5655147d2b8d490f9fedbbe6e.png',
        price_from: 10950
      },
      {
        link: '/seller/synthetic?category=C248479&ordering=rating&fo00007=true&fp00004=fbcb17750c954c0b8d8b0cac51583ce0&utm_source=black&utm_medium=champ',
        name: 'генератори',
        img: 'd82b672e5de04b6383446e47ffacc95d.jpg',
        price_from: 19950
      },
      {
        link: '/seller/synthetic?category=C320580&ordering=rating&fo00007=true&utm_source=black&utm_medium=note',
        name: 'ноутбуки',
        img: 'e5af914eb3ed48f49891bdf8f4ed7f32.webp',
        price_from: 4838
      },
      {
        link: '/seller/synthetic?category=C818594&ordering=rating&fo00007=true&fo00002=true&utm_source=black&utm_medium=pc',
        name: 'МІНІ-ПК',
        img: '570095d5c5c5438b8dc2089a6a77af01.jpg',
        price_from: 4700
      },
      {
        link: '/seller/synthetic?category=C644049&ordering=rating&fo00007=true&fo00002=true&utm_source=black&utm_medium=monitor',
        name: 'Монітори',
        img: '94b9ff1a17884324b01e07ac454e6319.jpg',
        price_from: 3160
      },
      {
        link: '/seller/synthetic?category=C441077&ordering=rating&fo00007=true&fo00002=true&utm_source=black&utm_medium=tab',
        name: 'Планшети',
        img: '0b7cf26bccac42f3a67a37de95cd9628.jpg',
        price_from: 1161
      },
      {
        link: '/seller/synthetic?category=C625687&ordering=-price&fo00007=true&fo00002=true&utm_source=black&utm_medium=watch',
        name: 'Смарт-годинники',
        img: '74dd9d21f3bf4f5396a61900af6046fb.webp',
        price_from: 1876
      },
      {
        link: '/seller/synthetic?category=C398790&ordering=-price&fo00007=true&fo00002=true&utm_source=black&utm_medium=headset',
        name: 'Навушники',
        img: '6f832196799a42e5b2588ca7fb3fe585.jpg',
        price_from: 2295
      },
      {
        link: '/seller/synthetic?category=C337965&ordering=rating&fo00007=true&fo00002=true&utm_source=black&utm_medium=phone',
        name: 'Смартфони',
        img: '55cbce51de344e008c111de212fb61c9.webp',
        price_from: 1699
      },
      {
        link: '/seller/synthetic?category=C358772&ordering=price&fo00007=true&fo00002=true&utm_source=black&utm_medium=project',
        name: 'Проектори',
        img: 'f3d81343e7bf4e518aa862fd75bcf2b3.png',
        price_from: 2399
      },
      {
        link: '/seller/synthetic?category=C050960&ordering=rating&fo00007=true&fo00002=true&utm_source=black&utm_medium=house',
        name: 'Побутова техніка',
        img: '45171379f7d54594b1737be6b77e087c.jpg',
        price_from: 10500
      }
    ],
    products: [],
    salePercent: 10,
    endDate: new Date('2024, 12, 02')
  },
  gs: {
    categories: [],
    products: gsProducts,
    salePercent: 5
  },
  gs10: {
    categories: [],
    products: gsProducts,
    salePercent: 10
    // promocodes: ['ENERGY5', 'саварютики5', 'LNJ10', 'брус5', 'Няшка 5', 'РП5', 'ivanlis']
  },
  gs15: {
    categories: [],
    products: gsProducts,
    salePercent: 15
    // promocodes: ['ENERGY5', 'саварютики5', 'LNJ10', 'брус5', 'Няшка 5', 'РП5', 'ivanlis']
  },
  sb: {
    categories: [],
    products: sbProducts,
    salePercent: 5
  },
  sb10: {
    categories: [],
    products: sbProducts,
    salePercent: 10
    // promocodes: ['ENERGY5', 'саварютики5', 'LNJ10', 'брус5', 'Няшка 5', 'РП5', 'ivanlis']
  },
  sb15: {
    categories: [],
    products: sbProducts,
    salePercent: 15
    // promocodes: ['ENERGY5', 'саварютики5', 'LNJ10', 'брус5', 'Няшка 5', 'РП5', 'ivanlis']
  }
}
